<template>
  <div class="viewport-list-box">
    <div class="list-box" v-if="viewportList.length">
      <div
        class="list-item-box"
        v-for="(item, index) in viewportList"
        :key="index"
      >
        <div class="name-box">
          <div v-if="item.isDefault" class="default-viewport-box">主视口</div>
          <div class="text-overflow" :title="item.name">{{ item.name }}</div>
        </div>
        <div class="img-box" @click="handleImgItemClick(item)">
          <img :src="getImgSrc(item)" />
        </div>
        <div class="bottom-box">
          <div class="time-box">
            {{ formatTime(item.creationTime) }}
          </div>
          <div class="btn-box">
            <el-button
              type="text"
              size="small"
              title="视口详情"
              @click.stop="openViewportDetailsPanel(item)"
            >
              <icon-svg icon-class="icon-xinxi" />
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-box" v-else>
      <div class="tip-box">
        <div class="img-box">
          <img :src="require('@/assets/img/no-params.png')" />
        </div>
        <div class="text-box">
          <span>暂无视口</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from "@/utils/generalMethods";

import { getSceneViewportDetailsService } from "@/service/share/sceneShareInterface.js";

export default {
  data() {
    return {};
  },
  props: {
    viewportList: Array,
  },
  methods: {
    handleImgItemClick(viewportInfo) {
      let visualAngle = JSON.parse(viewportInfo.visualAngle);

      let camLoc = new window.BlackHole3D.REForceCamLoc();
      camLoc.camPos = visualAngle.camPos;
      camLoc.camRotate = visualAngle.camRotate;
      window.BlackHole3D.Camera.setCamLocateTo(camLoc, 0.5, 1);
    },
    openViewportDetailsPanel(viewportInfo) {
      this.queryViewportDetails(viewportInfo).then((viewporDetails) => {
        this.$emit("openViewportDetailsPanel", viewporDetails);
      });
    },
    getImgSrc(viewportInfo) {
      let timestamp = new Date().getTime();
      let imgSrc = `${window.imageBaseUrl}/${viewportInfo.thumbnail}?timestamp=${timestamp}`;
      return imgSrc;
    },
    queryViewportDetails(viewportInfo) {
      return new Promise((resolve) => {
        let viewportId = viewportInfo.sceneViewPortId;
        let headers = this.getHeaders();
        getSceneViewportDetailsService(viewportId, headers).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            resolve(data);
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    getHeaders() {
      let token = this.$route.query.token;
      let headers = {
        Authorization: token,
      };
      return headers;
    },
    formatTime,
  },
};
</script>

<style lang="less" scoped>
.viewport-list-box {
  flex-grow: 1;
  overflow: hidden;

  .list-box {
    height: calc(100% - 8px);
    margin-top: 8px;
    overflow-y: auto;

    .list-item-box {
      margin-bottom: 8px;
      padding: 8px;
      border-radius: 8px;
      border: 1px solid var(--viewport-list-border-color);

      &:last-child {
        margin-bottom: 0;
      }

      .name-box {
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: left;

        .default-viewport-box {
          flex-shrink: 0;
          margin-right: 5px;
          font-size: 12px;
          padding: 0px 4px;
          color: var(--base-dark35-color);
          border-radius: 4px;
          border: 1px solid var(--base-dark35-color);
          background: var(--base-bg-light-color75);
        }
      }

      .img-box {
        margin: 4px 0px;
        height: 176px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }
      }

      .bottom-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 4px;

        .time-box {
          font-weight: 400;
          font-size: 14px;
          color: var(--viewport-text-color);
        }

        .btn-box {
          .el-button--text {
            margin-left: 0px;
            color: var(--viewport-btn-text-color);
            padding: 2px;

            &:hover {
              color: var(--base-primary-bgColor);
              background: var(--base-bg-light-color77);
            }
          }
        }
      }
    }
  }

  .empty-box {
    display: flex;
    height: 100%;

    .tip-box {
      margin: auto;
      font-size: 12px;
      color: var(--viewport-btn-empty-text-color);

      .text-box {
        width: 200px;
        margin: auto;
        line-height: 22px;
      }

      .bold-text-box {
        font-weight: bold;
        color: var(--viewport-btn-empty-bold-text-color);
      }
    }
  }
}
</style>